<template>
  <div>
    <b-row class="mb-2">
      <b-col md="4">
        <label for="search-city">Search by City</label>
        <b-form-input
          id="search-city"
          v-model="queryParams.city"
          placeholder="Enter City"
        />
      </b-col>
      <b-col
        md="8"
        class="d-flex justify-content-end align-items-end"
      >
        <b-button
          variant="primary"
          @click="fetchZones(queryParams)"
        >
          Search
        </b-button>
      </b-col>
    </b-row>
    <b-table
      hoverr
      striped
      :items="zones"
      :fields="zonesColumns"
      primary-key="id"
      show-empty
      empty-text="No matching zones found"
      selectable
      select-mode="single"
      @row-selected="onZoneSelected($event[0])"
    >
      <template #cell(status)="data">
        <b-badge
          pill
          :variant="`light-${resolveZoneStatusVariant(data.item.status)}`"
          class="text-capitalize"
        >
          {{ data.item.status }}
        </b-badge>
      </template>
    </b-table>
    <base-pagination
      v-model="queryParams.page"
      :total="totalServices"
      @new-per-page="queryParams.perPage = $event"
    />
  </div>
</template>

<script>
import {
  BTable, BBadge, BRow, BCol, BButton, BFormInput,
} from 'bootstrap-vue'
import { reactive, toRef, watch } from '@vue/composition-api'
import useZoneList from '@/views/zones/useZoneList'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import zonesStore from '@/views/zones/zoneStoreModule'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BTable,
    BBadge,
    BasePagination,
    BRow,
    BCol,
    BButton,
    BFormInput,
  },
  setup(_, { emit }) {
    const queryParams = reactive({
      page: 1,
      perPage: 10,
      city: '',
    })

    useRegisterStoreModule('zones', zonesStore)
    const zonesColumns = [
      { key: 'city' },
      { key: 'country' },
      { key: 'area' },
      { key: 'status' },
    ]

    const {
      tableData: zones, loadingZones, fetchZones, ...rest
    } = useZoneList(false)

    const onZoneSelected = event => {
      if (!event) {
        emit('zone-selected', null)
        return
      }
      emit('zone-selected', `${event.country}::${event.city}`)
    }
    watch(loadingZones, () => {
      emit('zones-loading-state', loadingZones.value)
    }, { immediate: true })

    fetchZones(queryParams)
    watch([toRef(queryParams, 'page'), toRef(queryParams, 'perPage')], () => {
      fetchZones(queryParams)
    })
    return {
      zonesColumns,
      ...rest,
      zones,
      onZoneSelected,
      queryParams,
      fetchZones,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
